import validator from "validator";

export const validation = {

  // validaciones globales

  required: value => !!value || 'Campo requerido',
  selectReq:value => !!value || 'Debe seleccionar un campo de la lista',
  numbers: [
      (val) => !!val || "numero requerido",
      (val) => validator.isNumeric(val) || "solo numeros",
      (val) => Number(val) >= 0 || "Debe ingresar un numero positivo",
    ],

  email: (val) => (val && validator.isEmail(val)) || "Correo invalido",

  email_null: [ value => {
    if(value == '') {
        return false
    }
    else{
        const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/
        return pattern.test(value) || 'Invalid e-mail.'
    }
}],

  validatePhone: [
    (val) => !!val || "Telefono requerido",
    (val) => val.length < 20 || "El numero es invalido",
  ],
  validateMovilphone: [
    (val) => !!val || "Telefono movil requerido",
    (val) => val.length <= 9 || "Coloque su numero de movil",
  ],

  validateName: [
    (val) => !!val || "Nombre requerido",
    (val) => val.length < 60 || "El nombre es demasiado largo",
    (val) => /^[a-zA-Z_ ]*$/.test(val) || "Por favor ingrese un nombre valido",
  ],

  min4: v => (v || '').length >= 4 || 'Mínimo 4 caracteres',
  min6: v => (v || '').length >= 6 || 'Mínimo 6 caracteres',
  min8: v => (v || '').length >= 8 || 'Mínimo 8 caracteres',
 
  max10: (val) => (val || "").length <= 10 || "Máximo 10 caracteres",
  max20: (val) => (val || "").length <= 20 || "Máximo 20 caracteres",
  max30: (val) => (val || "").length <= 30 || "Máximo 30 caracteres", 
  max50: (val) => (val || "").length <= 50 || "Máximo 50 caracteres",
  max60: (val) => (val || "").length <= 60 || "Máximo 60 caracteres",
  max100: (val) => (val || "").length <= 100 || "Máximo 100 caracteres",
  max150: (val) => (val || "").length <= 150 || "Máximo 150 caracteres",
  
  max5Mb: v => !v || v.every(file => file.size < 5000000) || 'El tamaño de los documento debe ser inferior a 5 MB!',
  max10Mb: v => !v || v.every(file => file.size < 10000000) || 'El tamaño de los documentos debe ser inferior a 10 MB!',
};
